var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-menu-item",
    _vm._g(
      {
        ref: "menuitem",
        staticClass: "ui-menu-item",
        class: { "ui-menu-item--confirm": _vm.showConfirm },
        attrs: { disabled: _vm.disabled },
        on: {
          "!click": function ($event) {
            $event.stopPropagation()
            return _vm.click.apply(null, arguments)
          },
          mouseleave: function ($event) {
            _vm.showConfirm = false
          },
        },
      },
      _vm.$listeners
    ),
    [
      _c("span", { staticClass: "ui-menu-item__label" }, [
        _vm._v(
          _vm._s(_vm.showConfirm ? _vm.confirmLabel || _vm.label : _vm.label)
        ),
      ]),
      _vm._v(" "),
      _vm.icon
        ? _c("i", {
            staticClass: "ui-menu-item__icon",
            class: _vm.showConfirm ? _vm.confirmIcon || _vm.icon : _vm.icon,
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.tooltip ? _c("md-tooltip", [_vm._v(_vm._s(_vm.tooltip))]) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }